module.exports = __webpack_public_path__ + "static/img/lucky_bg.23395598.png";